<!-- Modals -->
<app-deprecated-confirmation-dialog
    #confirmDeleteCustomReportDialog
    label="delete"
    description="reporting.custom-reports.areYouSureYouWantToDelete"
    [negative]="true"
></app-deprecated-confirmation-dialog>

<!-- Body -->
<div class="page-container" [class.loading]="isLoading">
    <app-header [title]="'reporting.custom-reports.title'" [menuService]="menuService">
        <div class="buttons" *ngIf="!table.isEmpty">
            <ui-button type="primary" url="new"
                ><mat-icon svgIcon="plus"></mat-icon
                >{{ 'reporting.custom-reports.createCustomReport' | translate }}</ui-button
            >
        </div>
    </app-header>

    <div class="customReports" *ngIf="!table.isEmpty; else emptyState">
        <!--show table if there are any reports-->
        <app-table [table]="table" (menuItemSelected)="onTableMenuEvent($event)">
            <app-empty-state label="reporting.custom-reports.noCustomReportsFound"></app-empty-state>
        </app-table>
    </div>

    <ng-template #emptyState>
        <!--empty state-->
        <div class="ui segment" style="position: relative">
            <h4 class="empty-state">
                {{ 'reporting.custom-reports.youHaveNotCreatedAnyReports' | translate }}
                <br />
                {{ 'reporting.custom-reports.createCustomReportsDescription' | translate }}
            </h4>
            <div class="ui centered header create-button">
                <ui-button type="primary" url="new">{{
                    'reporting.custom-reports.createCustomReport' | translate
                }}</ui-button>
            </div>
        </div>
    </ng-template>
</div>
